




















export default {
  props: ['payment', 'active'],
};

